
<modal
  title="Create Custom Index"
  size="full"
  :open="open"
  @close="closeModal"
>
  <section v-show="display === 'intro'" class="intro">
    <h4>Choose an option</h4>
    <p>
      We have two ways of building out a custom index. You can either define a subset of cards from our Ladder
      database to analyze or search individual cards manually to build your index.
    </p>

    <div class="cta-options">
      <div>
        <cta-card
          icon="construction"
          title="Define Subset"
          description="Choose from multiple parameters to build a subset of cards from our Ladder database"
          @click="display = 'subset'"
        />
      </div>

      <div>
        <cta-card
          icon="search"
          title="Search Cards"
          description="Add cards to your index manually one at a time by searching our Ladder database"
          @click="display = 'search'"
        />
      </div>
    </div>
  </section>

  <section class="form">
    <text-input
      v-show="display !== 'intro'"
      v-model.trim="label"
      label="Index Title"
      maxlength="24"
    />
  </section>

  <section v-show="display === 'search'" class="form">
    <p>
      Search our Ladder database and select the cards you want in your index. You must select at least 5 cards with a
      max of {{ searchLimit }} cards.
    </p>

    <div v-show="cardIds.length < searchLimit">
      <card-search
        placeholder="Search for a card"
        keep-open-on-select
        :exclude-ids="cardIds"
        @select="addCard"
      />

      <br />
    </div>

    <div v-for="card in cards" :key="card.id" class="card-item">
      <align no-gap>
        <icon-button icon="close" @click="removeCard(card.id)" />

        <card-list-item :card="card" :fields="['currentValue']" />
      </align>
    </div>
  </section>

  <section v-show="display === 'subset'" class="form">
    <p>
      Setup parameters for which cards will be included in your index. Each filter you apply will reduce the number
      of cards in your index from the Ladder. The number of cards in the index must be less than {{ subsetLimit }}.
    </p>

    <select-input
      v-model="filters.category"
      label="Category"
      searchable
      :options="categoryOptions"
    />

    <multiselect v-model="filters.conditions" label="Conditions" :options="conditionOptions" />

    <text-input
      v-model.trim="filters.player"
      label="Player"
      maxlength="64"
      :options="playerOptions"
      :loading="loadingPlayers"
      @input="loadPlayers"
    />

    <div class="input-group">
      <currency-input v-model="filters.minValue" label="Min Value" />

      <currency-input v-model="filters.maxValue" label="Max Value" />
    </div>

    <div class="input-group">
      <select-input v-model="filters.minYear" label="Min Year" :options="yearOptions" />

      <select-input v-model="filters.maxYear" label="Max Year" :options="yearOptions" />
    </div>

    <div class="input-group">
      <text-input v-model.trim="filters.minPop" type="number" label="Min Pop" />

      <text-input v-model.trim="filters.maxPop" type="number" label="Max Pop" />
    </div>

    <p v-show="cardCountString">
      {{ cardCountString }} cards in this index
    </p>
    <spinner v-show="loadingCardCount" inline />
  </section>

  <template #footer>
    <align v-show="display !== 'intro'" justify="space-between">
      <div class="button-row">
        <btn
          :loading="submitting"
          :disabled="disabled"
          loading-text="Submitting"
          @click="submit"
        >
          Submit
        </btn>
      </div>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </align>
  </template>
</modal>
